import { render, staticRenderFns } from "./NumberColumnsTextField.vue?vue&type=template&id=b1577bfe&"
import script from "./NumberColumnsTextField.vue?vue&type=script&lang=js&"
export * from "./NumberColumnsTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports